'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');
var session = require('../session/session.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Promotions {
  filter(type, lang, mobile, lobbyFilter, userName) {
    return __async(this, null, function* () {
      const user = session.session.getUser();
      const serverPromos = yield index.adapter.promotions.filter({
        lang,
        type,
        userName: userName || (user ? user.userName : void 0),
        lobbyFilter,
        isDevice: mobile
      });
      return serverPromos.map((serverPromo) => {
        var _a, _b;
        return __spreadProps(__spreadValues({}, serverPromo), {
          image: serverPromo.image[lang],
          title: serverPromo.title[lang],
          subtitle: serverPromo.subtitle[lang],
          background: serverPromo.background[lang],
          mobileBackground: (serverPromo.mobileBackground || {})[lang],
          link: serverPromo.link[lang],
          markdown: serverPromo.markdown[lang],
          values: __spreadProps(__spreadValues({}, serverPromo.values[lang] || {}), {
            cta: (((_a = serverPromo.values[lang]) == null ? void 0 : _a.cta) || []).map((cta) => __spreadProps(__spreadValues({}, cta), {
              link: cta[mobile ? "mobile" : "desktop"]
            })),
            tnc: ((_b = serverPromo.values[lang]) == null ? void 0 : _b.tnc) || ""
          })
        });
      }).sort((a, b) => a.position - b.position);
    });
  }
  optIn(name, lang, cta, userId) {
    const params = { name, lang, cta, userId };
    return index.adapter.promotions.optIn(params);
  }
  getByCatId(catId) {
    const params = { catId };
    return index.adapter.promotions.getByCatId(params);
  }
  getCategories(lang) {
    return index.adapter.promotions.getCategories({ lang }).then((categories) => {
      return categories.sort((a, b) => a.position - b.position);
    });
  }
}
const promotions = new Promotions();

exports.promotions = promotions;
